<template>
  <div
    class="deadlines-page homepage-main"
    :class="isContrast != 'false' && isContrast != false ? 'high-contrast' : ''"
  >
    <ShareScheme />
    <SaveScheme />
    <DownloadScheme />
    <span class="curr-nav row"
      >{{ t("navbar.dashboard") }} &#62;
      {{ t("my_dashboard.upcoming_deadlines") }}</span
    >

    <div class="grant-cards-container grants-container">
      <div class="pagination top-pag row justify-between">
        <span class="newest-heading bold-font">
          {{ t("my_dashboard.upcoming_deadlines") }}
        </span>
        <q-pagination
          class="pagination-item"
          v-model="currentPage"
          :max="maxPages"
          direction-links
          :max-pages="6"
          @click="goToPage(currentPage)"
          color="grey"
          active-color="green-7"
          text-color="white"
          size="13px"
          ref="paginationRef"
        ></q-pagination>
      </div>
      <div class="cards">
        <GrantCard
          v-for="grant in grants"
          :key="grant.id"
          :title="grant.name"
          :grant="grant"
          :id="grant.id"
          :introduction="grant.introduction"
          class="q-mt-md item"
        />
      </div>
      <div class="pagination top-pag row justify-end bot-pag">
        <q-pagination
          class="pagination-item"
          v-model="currentPage"
          :max="maxPages"
          direction-links
          :max-pages="6"
          @click="goToPage(currentPage)"
          color="grey"
          active-color="green-7"
          text-color="white"
          size="13px"
          ref="paginationRefBottom"
        ></q-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, computed, ref, nextTick } from "vue";
import SchemesUtils from "../../utils/schemes";
import store from "../../store/index";
import GrantCard from "../GrantCard.vue";
import ShareScheme from "../share-components/ShareScheme.vue";
import DownloadScheme from "../share-components/DownloadScheme.vue";
import SaveScheme from "../SaveScheme.vue";
import UserService from "../../services/userprofile.service";
import { useI18n } from "vue-i18n";
import qPaginationUtils from "../../utils/q-pagination-utils";
export default {
  name: "NewestSchemes",
  components: {
    GrantCard,
    ShareScheme,
    SaveScheme,
    DownloadScheme,
  },
  setup() {
    const { locale, t } = useI18n();

    const paginationRef = ref(null);
    const paginationRefBottom = ref(null);

    const grants = computed({
      get: () => store.state.homePageItems.grantsByDeadline,
    });

    const currentPage = computed({
      get: () => store.state.homePageItems.currentPageDeadlines,
      set: (val) =>
        store.commit("homePageItems/updateCurrentPageDeadlines", val),
    });

    const maxPages = computed({
      get: () => store.state.homePageItems.pageCountDeadlines,
    });

    const goToPage = async (page) => {
      if (!hasProfileTags.value) {
        await SchemesUtils.searchDeadlineSchemes(locale, page - 1, 10);
      } else {
        var locationsStr = "";
        for (let i = 0; i < favoriteLocations.value.length; i++) {
          // For German locations we send paths instead of ids
          if (
            locale.value === "de" &&
            favoriteLocations.value[i].path &&
            favoriteLocations.value[i].path != ""
          )
            locationsStr += favoriteLocations.value[i].path + ",";
          else locationsStr += favoriteLocations.value[i].id + ",";
        }
        locationsStr = locationsStr.substring(0, locationsStr.length - 1);
        await SchemesUtils.searchDeadlineSchemesWithTags(
          locale,
          page - 1,
          10,
          favoriteAudience.value,
          favoritePurposes.value,
          locationsStr
        );
      }
      window.scrollTo(0, 0);

      nextTick(() => {
        qPaginationUtils.addAriaLabels(t);
        qPaginationUtils.setAriaCurrentForPagination(paginationRef, page);
        qPaginationUtils.setAriaCurrentForPagination(paginationRefBottom, page);
      })
    };

    onMounted(async () => {
      await UserService.getProfileConfiguration();
      await UserService.getFavoriteAudienceTags(locale);
      await UserService.getFavoritePurposesTags(locale);
      await UserService.getFavoriteLocationsTags(locale);

      window.scrollTo(0, 0);
      checkForTagsUpdate();

      nextTick(() => {
        qPaginationUtils.setAriaCurrentForPagination(paginationRef, currentPage.value);
        qPaginationUtils.setAriaCurrentForPagination(paginationRefBottom, currentPage.value);
        qPaginationUtils.addAriaLabels(t);
      })

      if (!hasProfileTags.value) {
        await SchemesUtils.searchDeadlineSchemes(locale, 0, 10);
      } else {
        var locationsStr = "";
        for (let i = 0; i < favoriteLocations.value.length; i++) {
          // For German locations we send paths instead of ids
          if (
            locale.value === "de" &&
            favoriteLocations.value[i].path &&
            favoriteLocations.value[i].path != ""
          )
            locationsStr += favoriteLocations.value[i].path + ",";
          else locationsStr += favoriteLocations.value[i].id + ",";
        }
        locationsStr = locationsStr.substring(0, locationsStr.length - 1);
        await SchemesUtils.searchDeadlineSchemesWithTags(
          locale,
          0,
          10,
          favoriteAudience.value,
          favoritePurposes.value,
          locationsStr
        );
      }
    });

    const favoriteAudience = computed({
      get: () => store.state.user.favoriteAudiencesIdsArray,
    });
    const favoritePurposes = computed({
      get: () => store.state.user.favoritePurposesIdsArray,
    });
    const favoriteLocations = computed({
      get: () => store.state.user.selectedFavoriteLocations,
    });

    const hasProfileTags = ref(false);

    const checkForTagsUpdate = () => {
      if (
        favoriteAudience.value.length > 0 ||
        favoritePurposes.value.length > 0 ||
        favoriteLocations.value.length > 0
      ) {
        hasProfileTags.value = true;
      }
    };

    const isContrast = computed({
      get: () => store.state.user.isSelectedThemeContrast,
    });

    return {
      t,
      locale,
      isContrast,
      grants,
      currentPage,
      maxPages,
      goToPage,
      favoriteAudience,
      favoritePurposes,
      favoriteLocations,
      checkForTagsUpdate,
      paginationRef,
      paginationRefBottom
    };
  },
};
</script>
